import { supabase } from '../lib/supabaseClient';

/**
 * Segundo intento de login para el personal de OFICINA que escribe su correo real.
 *
 * La cuenta se autentica contra `<documento>@campo.treid.pe`, y Supabase admite UN correo por
 * cuenta, así que `npatino@treid.pe` no abre nada por sí solo. La Edge Function `login-oficina`
 * hace la traducción del lado del servidor y devuelve la sesión ya creada; el navegador nunca
 * aprende a qué documento corresponde ese correo (ver el encabezado de la función).
 *
 * Devuelve `true` si la sesión quedó puesta. Nunca lanza por credenciales: un `false` significa
 * "no entró", sin decir por qué, igual que el login normal.
 */
export async function ingresarComoOficina(
  identificador: string,
  clave: string,
): Promise<boolean> {
  let data: unknown;
  try {
    const res = await supabase.functions.invoke('login-oficina', {
      body: { identificador, clave },
    });
    // Un error de red o una función caída NO son un rechazo de credenciales: se responde que no
    // entró y el login muestra su mensaje de siempre. Esta puerta es un extra, no la principal.
    if (res.error) return false;
    data = res.data;
  } catch {
    return false;
  }

  const payload = data as
    | { ok?: boolean; session?: { access_token?: string; refresh_token?: string } }
    | null;
  const access_token = payload?.session?.access_token;
  const refresh_token = payload?.session?.refresh_token;
  if (!payload?.ok || !access_token || !refresh_token) return false;

  // `setSession` es lo que deja la sesión guardada y refrescándose sola, igual que si hubiera
  // entrado por `signInWithPassword`. Sin esto la sesión viviría solo en esta variable.
  const { error } = await supabase.auth.setSession({ access_token, refresh_token });
  return !error;
}
